import { memo, useEffect, useRef } from "react";
import { Chip, Grid2, Typography } from "@mui/material";
import ChatMessage from "./ChatMessage";
import { Message, MessageType } from "@/app/graphql/codegen";
import { useSelector } from "react-redux";
import { RootState } from "@/app/store";

interface ChatMessageContainerProps {
    chatId: string | undefined;
    messages: Message[];
    refetchMessages?: () => void;
    isGenerating?: boolean;
}

const ChatMessageContainer = memo(({ chatId, messages, refetchMessages, isGenerating = false }: ChatMessageContainerProps) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    
    // Get pending sent messages from Redux (these render INSTANTLY, before server confirms)
    const pendingMessages = useSelector((state: RootState) => 
        chatId ? (state.chat.pendingSentMessages[chatId] || []) : []
    );
    
    // Combine pending + server messages (pending first, so they appear at the end chronologically)
    const allMessages = [...messages, ...pendingMessages] as Message[];

    useEffect(() => {
        if (containerRef.current) {
            const lastElement = containerRef.current.lastElementChild;
            if (lastElement) {
                lastElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        }
    }, [allMessages]); // Scroll on ANY message change (pending or server)

    // Improved logic to determine if we should show the generating indicator
    const shouldShowGeneratingIndicator = isGenerating && 
        !allMessages.some((msg) => msg.type === MessageType.Bot && !msg.content.trim()) &&
        allMessages.length > 0; // Only show if there are actual messages

    return (
        <Grid2
            container
            size={12}
            spacing={2}
            direction={allMessages.length === 0 ? "row" : "column"}
            ref={containerRef}
            // maxHeight={"inherit"}
            px={1}
            // sx={{
            //     "& > *": {
            //         maxWidth: "100%",
            //     },
            // }}
        >
            {allMessages.length === 0 && !isGenerating ? (
                // <Grid2 container size={12} alignItems={"center"}>
                //     <Grid2 container direction={"column"} sx={{ opacity: 0.5 }} size={12}>
                //         <Grid2 size={12}>
                //             <Typography variant={"h1"} fontSize={"2rem"} align={"center"}>
                //                 ESG BOT
                //             </Typography>
                //         </Grid2>
                //
                //         <Grid2 size={12}>
                //             <Typography align={"center"}>Hallo, ich bin der ESGbot, wie kann ich heute helfen?</Typography>
                //         </Grid2>
                //
                //
                //     </Grid2>
                // </Grid2>

                <Grid2 container size={12}>
                    <Grid2 container size={12}>
                        <Grid2 key={"welcome"} size={12} /* ... other props ... */>
                            <ChatMessage
                                message={{
                                    id: crypto.randomUUID(),
                                    type: MessageType.Bot,
                                    content:
                                        "Hallo ich bin der ESGbot, herzlich willkommen im Chat. Für allgemeine Antworten bitte einfach fragen, für spezifische Suche nach Gesetzen bitte die SmartSearch oben auf der linken Seite auswählen und für einen direkten Blick ins Gesetz bitte das gewünschte Gesetz auf der linken Seite auswählen.",
                                    chatId: chatId || "",
                                    senderId: null,
                                }}
                                isGenerating={isGenerating}
                                refetchMessages={refetchMessages}
                                isSyntheticMessage={true}
                            />
                        </Grid2>
                    </Grid2>
                </Grid2>
            ) : (
                <>
                    {allMessages.map((message) => (
                        <Grid2 key={message.id} size={12} /* ... other props ... */>
                            <ChatMessage message={message} isGenerating={isGenerating} refetchMessages={refetchMessages} />
                        </Grid2>
                    ))}

                    {shouldShowGeneratingIndicator && (
                        <Grid2 size={12} justifyContent={"flex-start"}>
                            <ChatMessage
                                message={{
                                    id: crypto.randomUUID(),
                                    type: MessageType.Bot,
                                    content: "",
                                    chatId: chatId || "",
                                    senderId: null,
                                }}
                                isDummyMessage={true}
                            />
                        </Grid2>
                    )}
                </>
            )}
        </Grid2>
    );
});

export default ChatMessageContainer;
